import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import { Link, withRouter, WithRouterProps } from 'react-router';
import { Select } from './Select';
import { DsiSvgIcon, IconType } from './SvgIcon';
import { Button } from './Button';
interface Props {
  totalItems: number;
  offset: number;
  limit: number;
  onOffsetChange?: (newOffset: number) => void;
  query?: string;
  isMobile?: boolean;
  router: any;
}

interface State {
  totalPages: number;
}

class Pagination extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      totalPages: Math.ceil(props.totalItems / props.limit),
    };
  }

  public componentDidUpdate(prevProps) {
    if (this.props.totalItems !== prevProps.totalItems) {
      this.setState({
        totalPages: this.calcTotalPages(),
      });
    }
  }

  public render() {
    const { totalPages } = this.state;

    let pageNumbers: any;
    if (!this.props.isMobile) {
      pageNumbers = this.getPaginationButtons();
    } else {
      pageNumbers = this.getPaginationSelect();
    }

    return (
      <PaginationWrapper>
        {totalPages > 1 && <React.Fragment>{pageNumbers}</React.Fragment>}
      </PaginationWrapper>
    );
  }

  public onChangePage = e => {
    const {
      target: { name: fieldName, value },
    } = e;
    this.props.router.push(
      `${this.props.query}&offset=${this.getOffset(value)}`
        .replace('?&', '?')
        .replace(/(offset=).*?(&)/, ''),
    );
  };

  public toPage = (page: number): void => {
    this.props.router.push(
      `${this.props.query}&offset=${this.getOffset(page)}`
        .replace('?&', '?')
        .replace(/(offset=).*?(&)/, ''),
    );
  };

  public getNumbersInSelect = () => {
    const { totalPages } = this.state;
    const paginationNumbers: number[] = [];
    for (let i = 0; i < totalPages; i++) {
      paginationNumbers.push(i + 1);
    }
    return paginationNumbers;
  };

  public getPaginationButtons = (): JSX.Element[] => {
    const paginationButtons: JSX.Element[] = [];
    const currentPage = this.countCurrentPage();
    const { totalPages } = this.state;

    if (totalPages <= 7) {
      return this.createPageNumbersAll(currentPage);
    }

    if (currentPage > 2) {
      paginationButtons.push(
        <PaginationItem
          key={1}
          title={1}
          to={`${this.props.query}&offset=${this.getOffset(1)}`
            .replace('?&', '?')
            .replace(/(offset=).*?(&)/, '')}
          // onClick={this.handleButtonClick}
        >
          1
        </PaginationItem>,
      );
    }

    if (currentPage > 3) {
      paginationButtons.push(
        <PaginationSpacer key={'space'}>&hellip;</PaginationSpacer>,
      );
    }

    if (currentPage < totalPages) {
      if (currentPage === totalPages) {
        paginationButtons.push(
          <PaginationItem
            key={currentPage - 2}
            title={currentPage - 2}
            to={`${this.props.query}&offset=${this.getOffset(currentPage - 2)}`
              .replace('?&', '?')
              .replace(/(offset=).*?(&)/, '')}
            // onClick={this.handleButtonClick}
          >
            {currentPage - 2}
          </PaginationItem>,
        );
      }

      if (currentPage !== 1) {
        paginationButtons.push(
          <PaginationItem
            key={currentPage - 1}
            title={currentPage - 1}
            to={`${this.props.query}&offset=${this.getOffset(currentPage - 1)}`
              .replace('?&', '?')
              .replace(/(offset=).*?(&)/, '')}
            //  onClick={this.handleButtonClick}
          >
            {currentPage - 1}
          </PaginationItem>,
        );
      }

      paginationButtons.push(
        <PaginationItem
          key={currentPage}
          title={currentPage}
          to={`${this.props.query}&offset=${this.getOffset(currentPage)}`
            .replace('?&', '?')
            .replace(/(offset=).*?(&)/, '')}
          active={true}
          // onClick={this.handleButtonClick}
        >
          {currentPage}
        </PaginationItem>,
      );

      if (currentPage < totalPages - 1) {
        paginationButtons.push(
          <PaginationItem
            key={currentPage + 1}
            title={currentPage + 1}
            to={`${this.props.query}&offset=${this.getOffset(currentPage + 1)}`
              .replace('?&', '?')
              .replace(/(offset=).*?(&)/, '')}
            // onClick={this.handleButtonClick}
          >
            {currentPage + 1}
          </PaginationItem>,
        );
      }

      if (currentPage === 1) {
        paginationButtons.push(
          <PaginationItem
            key={currentPage + 2}
            title={currentPage + 2}
            to={`${this.props.query}&offset=${this.getOffset(currentPage + 2)}`
              .replace('?&', '?')
              .replace(/(offset=).*?(&)/, '')}
            //  onClick={this.handleButtonClick}
          >
            {currentPage + 2}
          </PaginationItem>,
        );
      }
    }

    if (currentPage < totalPages - 2) {
      paginationButtons.push(
        <PaginationSpacer
          key={'spacer2'}
          // onClick={this.handleButtonClick}
        >
          &hellip;
        </PaginationSpacer>,
      );
    }

    if (currentPage === totalPages) {
      paginationButtons.push(
        <PaginationItem
          key={totalPages - 2}
          title={totalPages - 2}
          to={`${this.props.query}&offset=${this.getOffset(totalPages - 2)}`
            .replace('?&', '?')
            .replace(/(offset=).*?(&)/, '')}
          // onClick={this.handleButtonClick}
        >
          {totalPages - 2}
        </PaginationItem>,
      );
    }

    if (currentPage === totalPages) {
      paginationButtons.push(
        <PaginationItem
          key={totalPages - 1}
          title={totalPages - 1}
          to={`${this.props.query}&offset=${this.getOffset(totalPages - 1)}`
            .replace('?&', '?')
            .replace(/(offset=).*?(&)/, '')}
          // onClick={this.handleButtonClick}
        >
          {totalPages - 1}
        </PaginationItem>,
      );
    }

    paginationButtons.push(
      <PaginationItem
        key={totalPages}
        title={totalPages}
        to={`${this.props.query}&offset=${this.getOffset(totalPages)}`
          .replace('?&', '?')
          .replace(/(offset=).*?(&)/, '')}
        active={currentPage === totalPages}
        // onClick={this.handleButtonClick}
      >
        {totalPages}
      </PaginationItem>,
    );

    return paginationButtons;
  };

  public getPaginationSelect = (): JSX.Element => {
    const options: Array<{ value: string; name: string }> = [];
    this.getNumbersInSelect().map(n => {
      options.push({ value: `${n}`, name: `${n}` });
    });

    const { totalPages } = this.state;
    const currentPage = this.countCurrentPage();

    return (
      <PaginationSelectCover>
        <PreviousIcon
          disabled={currentPage <= 1}
          // tslint:disable-next-line:jsx-no-lambda
          onClick={() => this.toPage(currentPage - 1)}
        >
          <DsiSvgIcon icon={IconType.arrowBack} />
        </PreviousIcon>

        <SelectCover>
          <Select
            marginBottom={0}
            name="page"
            required={true}
            value={currentPage}
            options={options}
            mobileMarginBottom={0}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={this.onChangePage}
          />
          <NumOfPage>z {totalPages}</NumOfPage>
        </SelectCover>

        <NextIcon
          disabled={currentPage >= totalPages}
          // tslint:disable-next-line:jsx-no-lambda
          onClick={() => this.toPage(currentPage + 1)}
        >
          <DsiSvgIcon icon={IconType.arrowNext} />
        </NextIcon>
      </PaginationSelectCover>
    );
  };

  public createPageNumbersAll(currentPage) {
    const { totalPages } = this.state;
    const paginationButtons: JSX.Element[] = [];

    for (let i = 1; i <= totalPages; i++) {
      paginationButtons.push(
        <PaginationItem
          key={i}
          title={i}
          to={`${this.props.query}&offset=${this.getOffset(i)}`
            .replace('?&', '?')
            .replace(/(offset=).*?(&)/, '')}
          active={currentPage === i}
          // onClick={this.handleButtonClick}
        >
          {i}
        </PaginationItem>,
      );
    }

    return paginationButtons;
  }

  public calcTotalPages = () => {
    return Math.ceil(this.props.totalItems / this.props.limit);
  };

  public countCurrentPage = () => {
    return Math.ceil(this.props.offset / this.props.limit + 1);
  };

  // public handleSelectChange = e => {
  //   const offset = prop(e, 'target.dataset.value');
  //   const diff = parseInt(offset, 10) - this.countCurrentPage();
  //   this.props.onOffsetChange(
  //     parseInt(this.props.offset.toString(), 10) + diff * this.props.limit,
  //   );
  // };

  // public handleButtonClick = e => {
  //   const diff = parseInt(e.target.text, 10) - this.countCurrentPage();
  //   this.props.onOffsetChange(
  //     parseInt(this.props.offset.toString(), 10) + diff * this.props.limit,
  //   );
  // };

  public getOffset = page => {
    const diff = parseInt(page, 10) - this.countCurrentPage();

    return parseInt(this.props.offset.toString(), 10) + diff * this.props.limit;
  };

  // public handleNextButtonClick = () => {
  //   const currentPage = this.countCurrentPage();
  //   if (currentPage === this.calcTotalPages()) {
  //     return;
  //   }
  //   this.props.onOffsetChange(
  //     parseInt(this.props.offset.toString(), 10) + this.props.limit,
  //   );
  // };

  // public handlePrevButtonClick = () => {
  //   const currentPage = this.countCurrentPage();
  //   if (currentPage === 1) {
  //     return;
  //   }

  //   this.props.onOffsetChange(
  //     parseInt(this.props.offset.toString(), 10) - this.props.limit,
  //   );
  // };
}

const PaginationSelectCover = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledButton = styled(Button)`
  background: transparent;
  padding: 0;
  width: initial;

  svg {
    fill: ${({ theme }) => theme.colors.textPrimary};

    * {
      fill: inherit;
    }
  }

  &:disabled {
    svg {
      fill: ${({ theme }) => rgba(theme.colors.textPrimary, 0.5)};
    }
  }
`;

const PreviousIcon = styled(StyledButton)``;
const NextIcon = styled(StyledButton)``;

const SelectCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NumOfPage = styled.span`
  display: inline-block;
  line-height: ${rem(18)};
  font-size: ${rem(14)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.primary};
  white-space: nowrap;
  margin-left: ${rem(12)};
`;

const PaginationWrapper = styled.div`
  font-size: ${rem(14)};
  line-height: 1;
  text-align: center;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PaginationItemStyles = css`
  display: inline-block;
  border-radius: ${rem(4)};
  text-align: center;
  padding: 0;
  margin: 0 ${rem(16)};
`;

const PaginationItem = styled(Link)<{ active?: boolean }>`
  ${PaginationItemStyles};
  text-decoration: none;
  padding: ${rem(11)} 0;
  width: ${rem(40)};
  line-height: ${rem(22)};
  font-size: ${rem(14)};
  font-weight: ${props => (props.active ? 400 : 300)};
  cursor: pointer;
  ${({ theme }) => theme.transitions('background-color, color')};
  color: ${props =>
    props.active
      ? ({ theme }) => theme.color.white
      : ({ theme }) => theme.colors.black};
  background-color: ${props =>
    props.active
      ? props.theme.colors.primary
      : props.theme.colors.paginationSecondary};
  border: 0;
  margin: 0;
  margin-right: ${rem(8)};
  border-radius: ${rem(2)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.color.white};
  }
`;

const PaginationSpacer = styled.span`
  ${PaginationItemStyles};
  width: ${rem(19)};
  padding-right: ${rem(20)};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  font-weight: 300;
  line-height: ${rem(22)};
`;

const PaginationWithRouter = withRouter(Pagination);
export { PaginationWithRouter as Pagination };
